import { render, staticRenderFns } from "./UseCases.vue?vue&type=template&id=116a9273&scoped=true&"
import script from "./UseCases.vue?vue&type=script&lang=js&"
export * from "./UseCases.vue?vue&type=script&lang=js&"
import style0 from "./UseCases.vue?vue&type=style&index=0&id=116a9273&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a9273",
  null
  
)

export default component.exports